"use client";

import { Reveal } from "@/components/motion/Reveal";
import { cn } from "@/lib/utils";

interface HomeSectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  className?: string;
  align?: "left" | "center";
  tone?: "light" | "dark";
}

export function HomeSectionHeader({
  eyebrow,
  title,
  subtitle,
  className,
  align = "center",
  tone = "light",
}: HomeSectionHeaderProps) {
  const isDark = tone === "dark";

  return (
    <Reveal amount="any">
      <div
        className={cn(
          "mb-8 md:mb-10",
          align === "center" && "text-center",
          className
        )}
      >
        {eyebrow && (
          <p
            className={cn(
              "mb-2 text-sm font-semibold uppercase tracking-[0.12em]",
              isDark
                ? "text-[var(--charity-gold)]"
                : "text-[var(--charity-green-dark)] dark:text-[var(--charity-gold)]"
            )}
          >
            {eyebrow}
          </p>
        )}
        <h2
          className={cn(
            "font-display mb-3 text-3xl font-bold md:text-4xl lg:text-5xl",
            isDark ? "text-white" : "text-foreground"
          )}
        >
          {title}
        </h2>
        {subtitle && (
          <p
            className={cn(
              "max-w-2xl text-base md:text-lg",
              isDark ? "text-white/80" : "text-muted",
              align === "center" && "mx-auto"
            )}
          >
            {subtitle}
          </p>
        )}
      </div>
    </Reveal>
  );
}
